'use client';

import { useUser } from '@/store';
import { useEffect } from 'react';

interface Input_CheckBoxProps {
	acknowledgedKYCNotice: boolean;
	setAcknowledgedKYCNotice: (acknowledgedKYCNotice: boolean) => void;
}

const Input_CheckBox_KYC_Notice = ({
	acknowledgedKYCNotice,
	setAcknowledgedKYCNotice,
}: Input_CheckBoxProps) => {
	const user = useUser();

	useEffect(() => {
		if (user?.moreDetails?.attestation) {
			setAcknowledgedKYCNotice(true);
		}
	}, [user]);

	return (
		<>
			<label className="flex gap-5 text-sm text-dove-white-o-70">
				<div className="relative flex items-center justify-center min-w-[18px] w-[18px] h-[18px] my-2.5">
					<input
						id="acknowledgedKYCNotice"
						name="acknowledgedKYCNotice"
						type="checkbox"
						className="invisible peer"
						checked={acknowledgedKYCNotice}
						onChange={(e) => setAcknowledgedKYCNotice(e.target.checked)}
					/>{' '}
					<div className="absolute inset-0 bg-transparent peer-checked:bg-electric-sky rounded border-2 border-electric-sky"></div>
					<svg
						className="absolute inset-0 m-auto w-2.5 h-2.5 text-white hidden peer-checked:block"
						xmlns="http://www.w3.org/2000/svg"
						width="12"
						height="9"
						viewBox="0 0 12 9"
						fill="none"
					>
						<path
							d="M1.5 5.2L4.35714 8L10.5 1"
							stroke="#F2F3F5"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				</div>
				<div className="flex-1 pr-5 py-2.5 leading-[150%]">
					<span className="font-bold">Read This:</span> We’re trusting you to be
					honest with this information. However, when it’s time to withdraw,
					you’ll have to complete KYC Level 2 and show official documents. If
					what you enter now doesn’t match those documents later, you won’t be
					able to withdraw, and you will be banned from the casino. Be honest
					now. Future you will appreciate it.
				</div>
			</label>
		</>
	);
};

export default Input_CheckBox_KYC_Notice;
